import { useEffect, useRef, RefObject } from 'react';

const useExternalHeader = (): RefObject<HTMLDivElement> => {
  const headerRef = useRef<HTMLDivElement>(null);

  // Hamburger click
  useEffect(() => {
    if (!headerRef?.current) return;

    const hamburger = headerRef.current.querySelector('.hamburger-desktop');
    const hamburgerMobile = headerRef.current.querySelector('.hamburger-mobile');

    const handler = (e: Event) => {
      const target = e.currentTarget as HTMLElement;

      target.classList.toggle('active');
      headerRef.current?.querySelector('.menus-wrapper')?.classList.toggle('active');
    };

    hamburger?.addEventListener('click', handler);
    hamburgerMobile?.addEventListener('click', handler);

    return () => {
      hamburger?.removeEventListener('click', handler);
      hamburgerMobile?.removeEventListener('click', handler);
    };
  }, []);

  // Submenu open/close
  useEffect(() => {
    if (!headerRef?.current) return;

    const menusWrapper = headerRef.current.querySelector('.menus-wrapper');

    const handler = (e: Event) => {
      const target = e.target as HTMLElement;

      const li = target.closest('li');

      if (li && li.classList.contains('menu-item-has-children')) {
        li.classList.toggle('active');
        li.querySelector('.sub-menu')?.classList.toggle('active');
      }
    };

    menusWrapper?.addEventListener('click', handler);

    return () => {
      if (!headerRef?.current) return;

      menusWrapper?.removeEventListener('click', handler);
    };
  }, []);

  // Search bar open/close
  useEffect(() => {
    if (!headerRef?.current) return;

    const searchOpen = headerRef.current.querySelector('.search-open');
    const searchDiv = headerRef.current.querySelector('.search-div');
    const searchClose = headerRef.current.querySelector('.search-close');
    const searchOpenMobile = headerRef.current.querySelector('.search-mobile');
    const searchDivMobile = headerRef.current.querySelector('.search-div-mobile');
    const searchCloseMobile = headerRef.current.querySelector('.search-close-mobile');
    const logo = headerRef.current.querySelector('.logo');
    const mobileButtons = headerRef.current.querySelector('.mobile-buttons');

    const handleOpen = () => {
      searchOpen?.classList.add('hidden');
      searchDiv?.classList.add('active');
    };

    const handleClose = () => {
      searchOpen?.classList.remove('hidden');
      searchDiv?.classList.remove('active');
    };

    const handleOpenMobile = () => {
      searchOpenMobile?.classList.add('hidden');
      searchDivMobile?.classList.add('active');
      logo?.classList.add('hidden');
      mobileButtons?.classList.add('active');
    };

    const handleCloseMobile = () => {
      searchOpenMobile?.classList.remove('hidden');
      searchDivMobile?.classList.remove('active');
      logo?.classList.remove('hidden');
      mobileButtons?.classList.remove('active');
    };

    searchOpen?.addEventListener('click', handleOpen);
    searchClose?.addEventListener('click', handleClose);
    searchOpenMobile?.addEventListener('click', handleOpenMobile);
    searchCloseMobile?.addEventListener('click', handleCloseMobile);

    return () => {
      searchOpen?.removeEventListener('click', handleOpen);
      searchClose?.removeEventListener('click', handleClose);
      searchOpenMobile?.removeEventListener('click', handleOpenMobile);
      searchCloseMobile?.removeEventListener('click', handleCloseMobile);
    };
  }, []);

  return headerRef;
};

export default useExternalHeader;
